<div class="container">
    <div class="row no-gutters">
        <div class="col-12">
            <div class="subheader with-padding flgrow">
                <div class="row align-items-center">
                    <div class="col-6 col-lg-3">
                        <div class="d-flex">
                            <div class="flex-grow-1">
                                <div class="input-group">
                                    <input class="form-control" type="text" name="searchTerm"
                                        placeholder="{{ 'lblSearch' | translate }}" [(ngModel)]="searchTerm"
                                        autocomplete="off" (keyup.enter)="onSearchFilter()" />
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
                                            <em class="fa fa-search"></em>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="ml-3">
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-2 col-lg-1">
                        <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" (click)="onRefresh()"
                            aria-label="Center Align">
                            <em class="fas fa-sync fa-lg"></em>
                        </a>
                    </div>
                    <div
                    class="col-xl-2 col-md-3 col-lg-1 d-flex align-items-center flex-sm-row flex-column justify-content-end ml-auto">
                    <button type="button" (click)="exportAsXLSX(documentTypes.Excel)" ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom"
                    aria-label="Center Align">
                    <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
                    </button>
                    <button class="ml-2 btn btn-link icon-pdf" type="button" (click)="onDownloadPDF(documentTypes.Pdf)"
                    ngbTooltip="{{'lblExportPDF' | translate}}" placement="bottom" aria-label="Center Align">
                    <em class="far fa-file fa-2x"></em>
                    <span class="bdg">PDF</span>
                  </button>
                </div>
                </div>

            </div>
            <div class="container prel">
                <div class="row">
                    <div class="c12">
                        <div class="card mb-3 scrollbar " [ngClass]="''">
                            <div class="card-header d-flex justify-content-between" translate>
                                lblContactUsers
                                <div class="font16 fontbold">
                                    <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                                    totalCount
                                    }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                                </div>
                            </div>
                            <div class="table-responsive max-h254" infinite-scroll
                                [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
                                [scrollWindow]="false" (scrolled)="onScrollDown($event)">
                                <table class="tablest1">
                                    <thead>
                                        <tr>
                                            <th style="width:55px" scope="col" translate>#</th>
                                            <th scope="col" style="width:100px" sortable="laborNo"
                                                (sort)="onSort($event)" translate>
                                                lblWoNo</th>
                                            <th scope="col" style="width:100px" sortable="customerName" (sort)="onSort($event)" translate>
                                                lblCustomerName</th>
                                            <th scope="col" style="width:100px" sortable="pincode" (sort)="onSort($event)" translate>
                                                lblAddress</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngIf="contactUserList?.length>0; else load_NotFound_Template">
                                            <tr *ngFor="let item of contactUserList; let i=index">
                                                <td>{{ item.rowNumber }}</td>
                                                <td>
                                                    <ngb-highlight [result]="item.woNumber">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                        <ngb-highlight class="fs-14px semibold lh-18px d-block"
                                                            [result]="item.customerName">
                                                        </ngb-highlight>
                                                        <div class="d-flex align-items-center mt-1 fs-12px lh-16px"
                                                            *ngIf="item.mobileNo">
                                                            <em _ngcontent-xdg-c220=""
                                                                class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                                                            <span class="fs-12px"
                                                                *ngIf="item.mobileCode">{{item.mobileCode}}-</span>
                                                            <ngb-highlight class="fs-12px" [result]="item.mobileNo">
                                                            </ngb-highlight>
                                                        </div>
                                                        <div class="d-flex align-items-center" *ngIf="item.email">
                                                            <em _ngcontent-xdg-c220=""
                                                                class="fas fa-envelope fs-10px fa-lg mr-2 clr666"></em>
                                                            <ngb-highlight class="fs-12px" [result]="item.email">
                                                            </ngb-highlight>
                                                        </div>
                                                    </td>
    
                                                    <td>
                                                        <ngb-highlight [result]="item.addressLine1">
                                                        </ngb-highlight>
                                                        <div class="d-flex align-items-center mt-1 fs-12px lh-16px">
                                                            <ngb-highlight class="fs-12px mr-2" [result]="item.pincode">
                                                            </ngb-highlight>
                                                            <ngb-highlight class="fs-12px" [result]="item.city">
                                                            </ngb-highlight>
                                                        </div>
                                                        <div class="d-flex align-items-center">
                                                            <ngb-highlight class="fs-12px" [result]="item.country">
                                                            </ngb-highlight>
                                                        </div>
                                                    </td>
                                            </tr>
                                        </ng-container>
                                        <ng-template #load_NotFound_Template>
                                            <tr>
                                                <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                            </tr>
                                        </ng-template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>








<!-- --------------------------------------------- PDF ------------------------------------------- -->

<div class="" style="display: none; margin-top: 300px;">
<div class="container prel" style="background-color: blue;">
    <div class="row">
        <div class="row mb-30">
            <div class="col-12">
                <div class="row pl-5 pr-5 pt-3 pb-3">
                    <div class="col-md-5">
                        <img class="brand" src="assets/images/sy-logo.png"
                            onError="this.onerror=null; this.src='../../../assets/images/no-image-icon.png'" alt=""
                            height="70" style="width:300px">
                    </div>
                    <div class="col-md-7">
                        <div class="Invoice_title" style="float: left;">
                            <p class="font-weight-bold" style="font-size:24px; color: white;">Contact User</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      <div class="c12">
        <div class="card mb-3">
          
          <div class="table-responsive max-h292">
            <table class="tablest1" id="PDFdata">
              <thead>
                <tr>
                  <th style="width: 55px" scope="col" translate>lblNo</th>
                  <th style="width: 15%" scope="col" translate class="text-center">
                    lblWoNo
                  </th>
                  <th style="width: 15%" scope="col" sortable="licensePlate" (sort)="onSort($event)" translate>
                    lblCustomerName
                  </th>
                  <th style="width: 10%" scope="col" sortable="licensePlate" (sort)="onSort($event)" translate>
                    lblMobileNo
                  </th>
                  <th style="width: 10%" scope="col" sortable="licensePlate" (sort)="onSort($event)" translate>
                    lblEmail
                  </th>
                  <th style="width: 20%" scope="col" translate>lblAddress</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="contactUserExcelList?.length > 0; else load_else">
                  <tr class="click" *ngFor="let customer of contactUserExcelList; let i = index" (click)="onClickPress(customer)">
                    <td>{{ i+1 }}</td>
                    <td>
                      <ngb-highlight [result]="customer.WoNo">
                      </ngb-highlight>
                    </td>
  
                    <td>
                        <ngb-highlight class="fs-14px semibold lh-18px d-block"
                        [result]="customer.CustomerName">
                    </ngb-highlight>
                    </td>
                    <td>
                        <ngb-highlight class="fs-12px" [result]="customer.MobilNo">
                        </ngb-highlight>
                    </td>
                    <td>
                        <ngb-highlight class="fs-12px" [result]="customer.Email">
                        </ngb-highlight>
                    </td>
                    <td>
                        <ngb-highlight [result]="customer.Address">
                        </ngb-highlight>
                    </td>
                  </tr>
                </ng-container>
                <ng-template #load_else>
                  <tr>
                    <td colspan="8" class="no-record" translate>
                      lblNoRecordsFound
                    </td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>